import React from "react";
import {
  View,
  StyleSheet,
  Image,
  Button,
  ActivityIndicator,
  ImageBackground,
  TouchableOpacity,
} from "react-native";
// import CodeInput from 'react-native-confirmation-code-input';
// import AsyncStorage from '@react-native-community/async-storage';
import { Snackbar, TextInput, Button as PaperButton, Surface } from "react-native-paper";
// import BackHandlerAndroid from './../AndroidBackHandler';
import {
  verifyChangePhoneNumber,
  clearVerifyChangePhoneNumber,
  changePhoneNumber,
  //  dispatchClearHomeInfo,
  clearChangePhoneNumber,
} from "./../../store/actions";
import { connect } from "react-redux";
// import DeviceInfo from 'react-native-device-info';
// import { resetAll } from './../../navigators/navigationService';
// import { isIos } from './../Utils';
// import StylesColors from './../Colors';
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import OfflineHandler from './../OfflineHandler';
import { Text, Styles } from "./../../components/UI-Components";
import OtpInput from "react-otp-input";
import Header from "./../../components/Header";


// import AdsScreen from './../Ads';

class verifyChangeNumber extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      snackbarMsg: "",
      otp:''
    };
  }

  componentWillUnmount() {
    this.props.clearVerifyChangePhoneNumber();
    this.props.clearChangePhoneNumber();
  }

  componentDidUpdate(prevProps) {
    if (this.props.status !== prevProps.status) {
      if (this.props.status === "success") {
        this.showSnackBar({
          snackbarMsg: "Phone number changed successfully",
          visible: true,
        });
        // this.props.dispatchClearHomeInfo();
        setTimeout(() => {
          this.props.history.push("Home");
          // this.props.navigation.navigate('Home');
        }, 900);
      }
      if (this.props.status === "failure") {
        this.showSnackBar({
          snackbarMsg: "Invalid OTP",
          visible: true,
        });
      }
    }

    if (prevProps.errInfo !== this.props.errInfo) {
      if (this.props.errInfo) {
        this.setState({
          visible: true,
          snackbarMsg: this.props.errInfo,
        });
      }
    }

    if (prevProps.resendSuccessMsg !== this.props.resendSuccessMsg) {
      if (this.props.resendSuccessMsg) {
        this.setState({
          visible: true,
          snackbarMsg: this.props.resendSuccessMsg,
        });
      }
    }

    if (prevProps.resendErr !== this.props.resendErr) {
      if (this.props.resendErr) {
        this.setState({
          visible: true,
          snackbarMsg: this.props.resendErrInfo,
        });
      }
    }
  }

  resendOTP = () => {
    const { mobileNo, changePhoneNumber, navigation } = this.props;
    if (mobileNo) {
      changePhoneNumber(mobileNo);
    } else {
      setTimeout(() => {
        navigation.navigate.goBack();
      }, 600);
    }
  };

  _onFulfill = (code) => {
    this.setState({
      otp: code,
    });
    this.props.verifyChangePhoneNumber(this.props.mobileNo, code);
  };

  handleChange = (otp) => {
    this.setState({ otp });
  };

  // static navigationOptions = ({ navigation }) => ({
  //     headerTitle: 'ENTER OTP',
  //     headerBackground:
  //         (<LinearGradientComponent />),
  //     headerStyle: {
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         color: StylesColors.headerTextColor,
  //         fontWeight: StylesColors.headerTextFontWeight,
  //         elevation:0,
  //         shadowOpacity:0,
  //         backgroundColor:Styles.white
  //     },
  //     headerTintColor: StylesColors.headerTintColor,
  //     headerTitleStyle: {
  //         color: StylesColors.headerTextColor,
  //         alignItems: 'center',
  //         alignSelf: 'center',
  //         // width: '80%',
  //         textAlign: 'center',
  //         fontWeight: StylesColors.headerTextFontWeight
  //     },
  // })
  showSnackBar = msg => {
    this.setState({
        visible: true,
        snackbarMsg: msg
    })
}

  render() {
    const { visible } = this.state;
    const { resendLoading, loading, mobileNo } = this.props;

    return (
      <>
         <Header
            title="Verify Number"
            title="Test Details"
            headerRight
            headerRightClick={() => this.props.history.push('/Home')}
            headerLeftClick={() => this.props.history.goBack()}
            backButton={true}
            />
          <div className='loginBox'
            // style={{
            //     flex: 1,
            //     backgroundColor: Styles.white,
            //     height: "90vh",
            //     elevation: 4,
            //     paddingVertical: 30,
            // }}
            >
            {/* <BackHandlerAndroid goBack={true}>
                    <OfflineHandler /> */}

            {
              // isIos ?
              //     (
              //         <View style={{ flex: 1, justifyContent: 'center', }}>
              //             <Text style={{ color: '#222', fontSize: 25, textAlign: 'center' }}>Verification Code</Text>
              //             <Text style={{ color: '#222', fontSize: 16, marginTop: 15, textAlign: 'center', color: '#29355f', marginHorizontal: 28 }}>
              //                 OTP has been sent to your mobile number.
              //                 Please verify
              //         </Text>

              //             <View>
              //                 <View style={{ marginHorizontal: 120 }}>
              //                     <TextInput
              //                         maxLength={6}
              //                         onChangeText={value => {
              //                             value.length >= 6 ? this._onFulfill(value) : null
              //                         }}
              //                         style={{ backgroundColor: 'transparent', paddingLeft: 0 }}
              //                         ref="codeInputRef1"
              //                         onFulfill={(code) => this._onFulfill(code)}
              //                         keyboardType={"number-pad"}
              //                     />
              //                     {/* {
              //                         loading || resendLoading ?

              //                             (
              //                                 <View style={{ justifyContent: 'center', alignItems: 'center', flex: 1 }}>
              //                                     <ActivityIndicator />
              //                                     {
              //                                         loading && (<Text style={{ textAlign: 'center', color: '#fff' }}>
              //                                             'Verifying Please Wait....'
              //                             </Text>)
              //                                     }

              //                                     {
              //                                         resendLoading && (<Text style={{ textAlign: 'center', color: '#fff' }}>
              //                                             'Sending Please Wait....'
              //                     </Text>)
              //                                     }

              //                                 </View>
              //                             )

              //                             : null
              //                     } */}

              //                 </View>
              //                 <View>
              //                     <View style={{ justifyContent: 'center', alignItems: 'center' }}>
              //                         <Text style={{ marginBottom: 15, textAlign: 'center', marginTop: 10 }}>Didn’t you receive verification code?</Text>
              //                     </View>
              //                     <View style={{ justifyContent: 'center', alignItems: 'center' }}>
              //                         <TouchableOpacity
              //                             title={'RESEND OTP'}
              //                             onPress={() => {
              //                                 this.resendOTP();
              //                             }}>

              //                             <Text style={{ color: Styles.primaryColor }}>Resend OTP</Text>
              //                         </TouchableOpacity>

              //                     </View>
              //                 </View>
              //             </View>
              //             <Snackbar
              //                 style={{ backgroundColor: '#fff', color: '#222' }}
              //                 visible={this.state.visible}
              //                 onDismiss={() => this.setState({ visible: false })}
              //                 action={{
              //                     label: 'close',
              //                     onPress: () => {
              //                         this.setState({ visible: false })
              //                     },
              //                 }}
              //             >
              //                 <Text style={{ color: '#222' }}>{this.state.snackbarMsg}</Text>
              //             </Snackbar>
              //         </View>
              //     )
              //     :

              // android verify phone

              <View style={styles.mainContainer}>
                <View
                  style={{
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Image
                    source={require("../../assets/otp.png")}
                    style={{ width: 111, height: 60 }}
                  />
                  <Text
                    style={{
                      color: "#29355F",
                      fontSize: 20,
                      marginLeft: 13,
                      marginTop: 15,
                    }}
                  >
                    Verification code
                  </Text>
                  <View
                    style={{
                      justifyContent: "center",
                      textAlign: "center",
                      alignItems: "center",
                    }}
                  >
                    <Text style={{ color: "#222", marginTop: 5 }}>
                      {" "}
                      OTP has been sent to your mobile number.
                    </Text>
                  </View>
                </View>
                <View
                  style={{
                    flex: 1,
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingTop: 0,
                    marginTop: 0,
                  }}
                >
                  <OtpInput
                    onChange={this.handleChange}
                    numInputs={6}
                    value={this.state.otp}
                    // separator={<span>-</span>}
                    shouldAutoFocus
                    containerStyle={{
                      marginTop: 24,
                      marginBottom: 24,
                    }}
                    inputStyle={{
                      padding: 12,
                      marginLeft: 8,
                      marginRight: 8,
                    }}
                    hasErrored
                    isInputNum
                  />
                  {loading || resendLoading ? (
                    <View
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <ActivityIndicator />
                      {loading && (
                        <Text style={{ textAlign: "center", color: "#fff" }}>
                          'Verifying Please Wait....'
                        </Text>
                      )}

                      {resendLoading && (
                        <Text style={{ textAlign: "center", color: "#fff" }}>
                          'Sending Please Wait....'
                        </Text>
                      )}
                    </View>
                  ) : null}
                  {
                    <PaperButton
                      style={styles.goButton}
                      disabled={loading || this.props.status ? true : false}
                      //  disabled={this.otpInput && this.otpInput.state && this.otpInput.state.digits && this.otpInput.state.digits.length >=6 ? false : true }
                      mode="contained"
                      onPress={() => {
                        // alert(JSON.stringify(this.otpInput.getDigits()));

                        const { otp } = this.state;
                        // const { params } = match || {};
                        // const { mobile } = params || {};
                        // console.log(otp, mobile, otp.length, !!mobile);
                        if (otp && String(otp).length >= 6 && mobileNo) {
                          return this.props.verifyChangePhoneNumber(mobileNo, otp);
                        }
                        this.showSnackBar("Incorrect otp");
                      }}
                      loading={this.props.loading ? true : false}
                    >
                      Proceed
                    </PaperButton>
                  }
                  <View style={{marginTop: 20}}>
                    <Text
                      style={{ marginBottom: 10, color: "#9D9D9D", fontSize: 12 }}
                    >
                      Didn’t you receive verification code?
                    </Text>
                  </View>
                  <Button
                    disabled={resendLoading || loading}
                    style={{
                      flex: 1,
                      paddingVertical: 30,
                      marginTop: 20,
                      backgroundColor: Styles.primaryColor,
                    }}
                    title={"RESEND OTP"}
                    onPress={() => {
                      this.resendOTP();
                    }}
                  />
                </View>

                <Snackbar
                  style={{ backgroundColor: "#fff", color: "#222" }}
                  visible={this.state.visible}
                  onDismiss={() => this.setState({ visible: false })}
                  action={{
                    label: "close",
                    onPress: () => {
                      this.setState({ visible: false });
                    },
                  }}
                >
                  <Text style={{ color: "#222" }}>{this.state.snackbarMsg}</Text>
                </Snackbar>
              </View>
            }
            {/* <AdsScreen screenName={'VerifyChangeNumber'} /> */}
            {/* </BackHandlerAndroid> */}
          </div>
      </>
    );
  }
}

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    alignItems: "center",
    paddingBottom: 20,
  },
  goButton: {
    minWidth: 50,
    paddingHorizontal: 8,
    //   paddingVertical: 7,
    backgroundColor: Styles.themeColor,
    alignItems: 'center',
    alignSelf: 'center',
    borderRadius: 15,
    color: '#fff',
    //   marginTop: 2

}
});

const mapStateToProps = (state) => ({
  mobileNo:
    state.changePhoneNumber &&
    state.changePhoneNumber.requestedMobileNo &&
    state.changePhoneNumber.requestedMobileNo,
  loading:
    state.verifyChangeNumber &&
    state.verifyChangeNumber.loading &&
    state.verifyChangeNumber.loading,
  err:
    state.verifyChangeNumber &&
    state.verifyChangeNumber.err &&
    state.verifyChangeNumber.err,
  errInfo:
    state.verifyChangeNumber &&
    state.verifyChangeNumber.errorInfo &&
    state.verifyChangeNumber.errorInfo.response &&
    state.verifyChangeNumber.errorInfo.response.data &&
    state.verifyChangeNumber.errorInfo.response.data.message &&
    state.verifyChangeNumber.errorInfo.response.data.message,
  status:
    state.verifyChangeNumber.response &&
    state.verifyChangeNumber.response.status &&
    state.verifyChangeNumber.response.status,
  resendLoading:
    state.changePhoneNumber &&
    state.changePhoneNumber.loading &&
    state.changePhoneNumber.loading,
  resendErr:
    state.changePhoneNumber &&
    state.changePhoneNumber.err &&
    state.changePhoneNumber.err,
  resendErrInfo:
    state.changePhoneNumber &&
    state.changePhoneNumber.errorInfo &&
    state.changePhoneNumber.errorInfo.response &&
    state.changePhoneNumber.errorInfo.response.data &&
    state.changePhoneNumber.errorInfo.response.data.message &&
    state.changePhoneNumber.errorInfo.response.data.message,
  resendSuccessMsg:
    state.changePhoneNumber.response &&
    state.changePhoneNumber.response.success &&
    state.changePhoneNumber.response.success,
});

export default connect(mapStateToProps, {
  verifyChangePhoneNumber,
  clearVerifyChangePhoneNumber,
  changePhoneNumber,
  //  dispatchClearHomeInfo,
  clearChangePhoneNumber,
})(verifyChangeNumber);
